import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface CustomerSourceDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
const CustomerSourceDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: CustomerSourceDeleteProps) => {
  const { t } = useTranslation();
  return (
    <CustomSharedConfirmationModal
      open={open}
      title={`${t("delete")} ${t("source")}`}
      description={t("delete_resource_description", { name: t("source") })}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};
export default CustomerSourceDelete;
